import {IBaseFormFieldSettings} from "../base-form-field.settings";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IChipsFieldSettings extends IBaseFormFieldSettings{

}
